import axios from '@/request/http'
import base from '@/request/base'

const template = {
  /** 获取广告模板分类 */
  getTemplateCategory() {
    return axios.get(`${base.admin_url}/cloud/Advoperate/adv_template_category`)
  },

  /**
   * 获取广告模板列表
   * @param {String} data
   */
  getTemplateList(data) {
    return axios.get(`${base.admin_url}/cloud/Advoperate/adv_template_list`, { params: data })
  },

  /**
   * 获取广告模板详情
   * @param {String} id 模板id
   */
  getTemplateDetail(id) {
    return axios.get(`${base.admin_url}/cloud/advoperate/adv_template_detail?id=${id}`)
  },

  /**
   * FB授权登录
   * @param {Object} data 用户FB授权信息
   */
  FBLogin(data) {
    return axios.post(`${base.admin_url}/cloud/Advoperate/fb_authorize`, data)
  },

  /** 获取所有授权用户 */
  getFBAuthUser() {
    return axios.get(`${base.admin_url}/cloud/advoperate/authorize_list`)
  },

  /**
   * 判断授权是否过期
   * @param {String} id 用户id
   */
  getFBAuthExpire(id) {
    return axios.get(`${base.admin_url}/cloud/advoperate/judge_authorize?id=${id}`)
  },

  /**
   * 获取用户所有广告账户
   * @param {String} id 用户id
   * @param {String} page 页码
   * @param {String} keyword 搜索关键字
   */
  getFBAdAccount(id, page, keyword) {
    return axios.get(`${base.admin_url}/cloud/advoperate/account_list?id=${id}&page=${page}&keyword=${keyword}`)
  },

  /**
   * 获取FB账户所有公共主页和像素
   * @param {String} id 账户id
   * @param {String} user_id 用户id
   */
  getPageAndPixel(account_id, user_id) {
    return axios.get(`${base.admin_url}/cloud/advoperate/get_pixel_page?account_id=${account_id}&user_id=${user_id}`)
  },

  /**
   * 获取广告模板受众信息选项
   * @param {Number} t_id
   * @returns
   */
  getAllAudience(t_id) {
    return axios.get(`${base.admin_url}/cloud/advoperate/adv_data?t_id=${t_id}`)
  },

  /**
   * 创建广告
   * @param {Object} data 广告模板信息
   */
  createFBAd(data) {
    return axios.post(`${base.admin_url}/cloud/advoperate/create_adv`, data, { isDebounce: true })
  },

  /** 判断用户ip是否可访问Facebook */
  getIp() {
    return axios.get(`${base.admin_url}/cloud/advoperate/get_ip`)
  },

  /** 事件埋点 */
  handleEventTracking(data) {
    return axios.post(`${base.admin_url}/cloud/Advoperate/adv_statistics`, data)
  },

  /**
   * 删除预设模板
   * @param {Number} t_id 预设模板id
   */
  deletePresetTemplate(t_id) {
    return axios.post(`${base.admin_url}/cloud/advoperate/delete_preset_template`, { t_id })
  },

  /**
   * 判断预设模板是否重名
   * @param {String} title 模板名称
   */
  judgeTemplateName(title) {
    return axios.get(`${base.admin_url}/cloud/advoperate/judge_same_name?title=${title}`)
  },

  /**
   * 重命名预设模板
   * @param {Object} data
   */
  renameTemplate(data) {
    return axios.post(`${base.admin_url}/cloud/advoperate/rename_preset_template`, data)
  },

  /**
   * 创建预设模板
   * @param {Object} data
   */
  createPresetTemplate(data) {
    return axios.post(`${base.admin_url}/cloud/advoperate/preset_template`, data)
  },

  /**
   * 获取模板分享链接
   * @param {Number} id
   */
  getShareUrl(id) {
    return axios.post(`${base.admin_url}/cloud/advoperate/share_preset_template?t_id=${id}`)
  },

  /**
   * 处理预设模板分享链接参数
   * @param {String} token
   */
  handleShareUrl(token) {
    return axios.post(`${base.admin_url}/cloud/advoperate/reception_share_preset_template`, { token })
  },

  /**
   * 保存分享的预设模板
   * @param {Object} data
   */
  saveSharedPresetTemplate(data) {
    return axios.post(`${base.admin_url}/cloud/advoperate/preservation__share_preset_template`, data)
  },
}

export default { template }
